module.exports = __webpack_public_path__ + "assets/dienst6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/dienst6.jpg
// module id = 362
// module chunks = 0